import { createSlice } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';
import cookie from 'app/services/system/cookie';

const uuid = cookie.get('uuid') || uuidv4();
const isLogged = cookie.get('isLogged') === 'true';

const initialState = {
  user: { uuid },
  isLogged: isLogged,
  token: null,
  requesting: false,
  signingout: false,
  errors: null,
};

const signInSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    // TRIGGERS saga
    signInRequest: (state, action) => {
      state.requesting = true;
    },

    // SUCCESS from saga
    signInSuccess: (state, action) => {
      const { user, token, isLogged } = action.payload;
      // console.log('...isLogged', isLogged)
      // console.log('...user', user)
      state.user = user;
      state.token = token;
      state.isLogged = isLogged;
      state.requesting = false;
      state.errors = null;

    },

    // FAILURE from saga
    signInFailed: (state, action) => {
      state.user = { uuid };
      state.token = null;
      state.isLogged = false;
      state.errors = action.payload;
      state.requesting = false;
    },

    // SIGNOUT
    signOutRequest: (state) => {
      state.signingout = true;
    },
    signOutSuccess: (state) => {
      state.user = { uuid };
      state.token = null;
      state.isLogged = false;
      state.errors = null;
      state.signingout = false;
    },
  },
});

export const {
  signInRequest,
  signInSuccess,
  signInFailed,
  signOutRequest,
  signOutSuccess,
} = signInSlice.actions;

export const Auth = signInSlice.reducer

export default signInSlice.reducer;